<template>
    <div class="home">
        <!--    <img alt="Vue logo" src="../assets/logo.png">-->
        <!--    <HelloWorld msg="Welcome to Your Vue.js App"/>-->
        <div v-if="homeContent">
            <VueShowdown :markdown="this.homeContent.content"></VueShowdown>

        </div>

    </div>
</template>

<script>
    // @ is an alias to /src
    import HelloWorld from '@/components/HelloWorld.vue'
    import Sidebar from "../components/Sidebar";

    export default {
        name: 'Home',
        components: {
            Sidebar,
            HelloWorld
        },
        computed: {
            homeContent: function () {
                return this.$store.state.homeContent
            }
        }
        ,
        mounted() {
            this.$store.dispatch("GET_HOMECONTENT_FROM_API")

        }
    }
</script>
